import { AxiosRequestHeaders, AxiosResponse, InternalAxiosRequestConfig } from './types'
import { ElMessage } from 'element-plus'
import qs from 'qs'
import { SUCCESS_CODE, TRANSFORM_REQUEST_DATA } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { filterStringTrim, objToFormData } from '@/utils'
import { useUserStore } from '@/store/modules/user'
import { commonEnums } from '@/enumerations'

const defaultRequestInterceptors = (config: InternalAxiosRequestConfig) => {
  const { getUserInfo } = useUserStore()

  const jwtToken = getUserInfo?.jwtToken

  if (jwtToken) {
    ;(config.headers as AxiosRequestHeaders)['Authorization'] = 'Bearer ' + jwtToken
  }

  ;(config.headers as AxiosRequestHeaders)['App-Key'] = 'SEtDRlAgZVBvcmZvbGlv'

  if (
    config.method === 'post' &&
    config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
  ) {
    config.data = qs.stringify(config.data)
  } else if (
    TRANSFORM_REQUEST_DATA &&
    config.method === 'post' &&
    config.headers['Content-Type'] === 'multipart/form-data' &&
    !(config.data instanceof FormData)
  ) {
    config.data = objToFormData(config.data)
  } else if (
    config.method === 'post' &&
    config.headers['Content-Type'] === 'application/json' &&
    config.responseType != 'blob'
  ) {
    config.data = filterStringTrim(config.data)
  }
  if (config.method === 'get' && config.params) {
    let url = config.url as string
    url += '?'
    const keys = Object.keys(config.params)
    for (const key of keys) {
      if (config.params[key] !== void 0 && config.params[key] !== null) {
        url += `${key}=${encodeURIComponent(config.params[key])}&`
      }
    }
    url = url.substring(0, url.length - 1)
    config.params = {}
    config.url = url
  }
  return config
}

const defaultResponseInterceptors = (response: AxiosResponse) => {
  if (response?.config?.responseType === 'blob') {
    // 如果是文件流，直接过
    return response
  } else if (response.data.statusCode === SUCCESS_CODE) {
    const data = response.data.data

    if (data) {
      Object.keys(data).forEach((key) => {
        if (typeof data[key] == 'object') {
          const objData = data[key]
          Object.keys(objData).forEach((k) => {
            if (objData[k] === '1753-01-01T00:00:00') {
              objData[k] = undefined
            }
          })
        }

        if (data[key] === '1753-01-01T00:00:00' || data[key] === commonEnums.SelectType.All) {
          data[key] = undefined
        }
      })
    }

    return response.data
  } else if (response.status == SUCCESS_CODE) {
    return response.data
  } else {
    ElMessage.error(response?.data?.message)
    if (response?.data?.code === 401) {
      const userStore = useUserStoreWithOut()
      userStore.logout()
    }
  }
}

export { defaultResponseInterceptors, defaultRequestInterceptors }
